import deactivateCharm from '../actions/deactivateCharm';
import { deactivateHelpCharmAction } from 'owa-help-charm/lib/actions/deactivateHelpCharmAction';
import { orchestrator } from 'satcheljs';
export default orchestrator(deactivateHelpCharmAction, function hideSettings() {
    deactivateCharm(2 /* HelpCharm */);
});
//# sourceMappingURL=deactivateHelpCharm.js.map